import React from 'react';
import { pick, prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { Link } from 'js/components/common/Link';
import { useComponentTranslations } from 'js/hooks/component';

import style from './Logo.scss';

export const LogoMobile: React.FC = () => {
    const { requestStamp, themeName } = useAppSelector(pick(['requestStamp', 'themeName']));
    const translate = useComponentTranslations();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const casinoname = searchParams.get('casinoname');
    const site = searchParams.get('site');
    const params = new URLSearchParams({
        t: `${requestStamp}`,
        ...casinoname && { casinoname },
        ...site && { site }
    });
    const logoURL = `/${themeName}/images/logo.svg?${params.toString()}`;
    const logoGuest = `/${themeName}/images/logo_byCasino_yellow_black.webp?${params.toString()}`;

    return (
        isLoggedIn ? (
            <div className={style.logo}>
                <img
                    className={style.logoImage}
                    src={logoURL}
                    alt={translate('header.menu.alt')}/>
            </div>
        ) : (<div className={style.logoCenter}>
            <Link href="/" aria-label={translate('header.logo.label')}>
                <img
                    className={style.logoImage}
                    src={logoGuest}
                    aria-label={translate('header.logo.label')}
                    alt={translate('header.logo.alt')}/>
            </Link>
        </div>)
    );
};
